export default __webpack_public_path__ + "static/media/background_service_card_4.b458f6f2.png";